module.exports = __webpack_public_path__ + "img/badge_viaggi_main_level.9aa24409.jpg";